const usertransaction = {
    getlist: 'usertransaction/getlist',
    add: 'usertransaction/add',
    update: 'usertransaction/update',
    remove: 'usertransaction/remove',
    get: 'usertransaction/get',
    getall: 'usertransaction/getall',
    clearcache: 'usertransaction/clear-cache',
}
export default usertransaction
